export const getCustomDuration = (value, type) => (
  type === 'hours'
    ? parseFloat(value) * 60
    : parseInt(value, 10)
)
